import { registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { Resources } from '../resource';
import { maintenanceBannerDataProvider } from './dataProvider';

registerModuleDataProvider(Resources.announcementPopup, maintenanceBannerDataProvider);
